<template>
    <div class="card mb-4">

        <h4 class="card-header">
            {{ job.number }} <span class="text-info float-right">Edit Mode</span>
        </h4>

        <div class="card-body">

            <form method="post" autocomplete="off">

                <div v-if="errors">
                    <div v-for="error of errors" :key="error.message">
                        <div class="alert alert-dismissible fade show" role="alert" :class="error.type">
                            {{error.message}}

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-9 col-sm-12">
                        <label for="id_title"><b>Title:</b></label>
                        <input type="text" v-model="title" name="title" class="form-control mb-4" required id="id_title">
                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <label for="id_location"><b>Location:</b></label>
                        <input type="text" v-model="location" name="location" class="form-control mb-4" required id="id_location">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-9 col-sm-12">
                        <label for="id_description"><b>Description:</b></label>
                        <input type="text" v-model="description" name="description" class="form-control mb-4" required id="id_description">

                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <label for="id_project_manager"><b>Project Manager:</b></label>
                        <select v-model="project_manager" type="text" name="number" class="form-control mb-4" required id="id_project_manager">
                            <option value="" selected>------------</option>
                            <option v-for="pm in pm_list" :key="pm.pk" :value="pm.pk">{{pm.first_name}} {{pm.last_name}}</option>
                        </select>

                    </div>
                </div>

                <hr>

                <label for="id_remarks"><b>Remarks:</b></label>
                <textarea name="remarks" v-model="remarks" class="form-control mb-4" required id="id_remarks" cols="40" rows="6"/>

                <div class="form-check">
                    <input id="id_active" v-model="active" type="checkbox" class="form-check-input">
                    <label for="id_active" class="form-check-label"><b>Active</b></label>
                </div>

                <div class="">


                    <button type="button" class="btn float-right ml-1" :class="[successful ? 'btn-success' : 'btn-primary']" @click="submitEditedJob" :disabled="loading"  data-toggle="tooltip" data-placement="top" title="Submit New Job">
                        <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                        <span>{{buttonText}}</span>
                        <font-awesome-icon v-if="successful" icon="check"/>
                    </button>

                    <button type="button" class="btn btn-secondary float-right" @click="emitClose"  data-toggle="tooltip" data-placement="top" title="Cancel Edit">Cancel</button>
                </div>

            </form>

        </div>

    </div>
</template>

<script>
    export default {
        name: "EditJob",
        data() {
            return {
                title: this.job.title,
                location: this.job.location,
                description: this.job.description,
                project_manager: this.job.project_manager,
                remarks: this.job.remarks,
                active: true,

                successful: false,
                loading: false,
                errors: [],
            }
        },
        props: {
            job: Object,
        },
        methods: {
            pushError(error) {
                this.removeError(error.message);
                this.errors.push(error)
            },
            removeError(error_message) {
                for( let i = 0; i < this.errors.length; i++) {
                    if ( this.errors[i].message === error_message) {
                        this.errors.splice(i, 1)
                    }
                }
            },
            submitEditedJob() {

                this.loading = true;

                let payload = {
                    action: 'submitJobEdit',
                    data: {
                        number: this.job.number,
                        title: this.title,
                        description: this.description,
                        location: this.location,
                        remarks: this.remarks,
                        project_manager: this.project_manager,
                        active: this.active
                    }
                };

                this.$store.dispatch('tryRefresh', payload).then((response) => {
                    // eslint-disable-next-line no-console
                    console.log(response);
                    this.loading = false;
                    this.successful = true;

                    setTimeout(() => {

                        this.$emit('job_edit_submitted');

                        // Reset data and close
                        this.active = true;
                        this.successful = false;

                        this.errors = [];

                    },500);

                }).catch(e => {
                    this.loading = false;
                    this.successful = false;

                    // eslint-disable-next-line no-console
                    console.log(e.response.data);

                    let errors = e.response.data;
                    let fields = Object.keys(errors);

                    // eslint-disable-next-line no-console
                    console.log(fields);

                    for(let i = 0; i < fields.length; i++){

                        let error_arr = errors[fields[i]];

                        for(let j = 0; j < error_arr.length; j++){
                            this.pushError({message: fields[i] + ': ' + error_arr[j], type: 'alert-warning'})
                        }
                    }
                })

            },
            emitClose() {
                this.$emit('toggleEdit');
            },
        },
        computed: {
            pm_list: function () {
                return this.$store.getters.project_manager_list
            },
            buttonText: function() {
                if(this.loading) {
                    return 'Loading...'
                } else if(this.successful) {
                    return 'Success '
                } else {
                    return 'Submit Edit'
                }
            },


        }
    }
</script>

<style scoped>

</style>